var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "discounts-shadow mb-2" }, [
    _c(
      "div",
      {
        staticClass: "discounts-box p-2",
        on: {
          click: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
            _vm.expanded = !_vm.expanded
          }
        }
      },
      [
        _c("div", { staticClass: "row w-100 mx-1" }, [
          _c(
            "div",
            { staticClass: "discounts-info-wrapper col-3 p-0" },
            [
              _c(
                "router-link",
                {
                  attrs: {
                    to: { path: "/jobs/edit/" + _vm.discount.job_id },
                    target: "_blank"
                  }
                },
                [
                  _c("div", { staticClass: "discount-ref-id pointer" }, [
                    _vm._v(_vm._s(_vm.discount.ref_id))
                  ])
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "total-info" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.discount.move_date) + "\n        "
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "discounts-info-wrapper col-3 p-0" }, [
            _c("div", { staticClass: "total-info-numbers text-center" }, [
              _vm._v("\n          " + _vm._s(_vm.discount.name) + "\n        ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "discounts-info-wrapper col-3 p-0" }, [
            _c(
              "div",
              { staticClass: "total-info-numbers text-center pl-2" },
              [
                _vm.discount.discount_unit_type_id === 1
                  ? [
                      _vm._v(
                        "\n            $" +
                          _vm._s(_vm.discount.amount) +
                          "\n          "
                      )
                    ]
                  : _vm.discount.discount_unit_type_id === 2
                    ? [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.discount.amount) +
                            " (" +
                            _vm._s(_vm.discount.amount_percent) +
                            "%)\n          "
                        )
                      ]
                    : _vm._e()
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "discounts-info-wrapper col-3 p-0" }, [
            _c("div", { staticClass: "total-info-numbers pr-2 text-right" }, [
              _vm._v("\n          " + _vm._s(_vm.discount.type) + "\n        ")
            ])
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.expanded
      ? _c("div", { staticClass: "discounts-box p-2" }, [
          _c("div", { staticClass: "border-top-expanded row mx-1 w-100" }, [
            _c("div", { staticClass: "col-12 row mt-2 pr-0" }, [
              _c("div", { staticClass: "col-4" }, [
                _c("label", { staticClass: "expanded-label" }, [
                  _vm._v("Booked company")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "expanded-col-data" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.discount.company) +
                      "\n          "
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-4" }, [
                _c("label", { staticClass: "expanded-label" }, [
                  _vm._v("Carrier")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "expanded-col-data" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.discount.carrier) +
                      "\n          "
                  )
                ])
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11499646", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11499646","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/DiscountsBlockMobile.vue
// module id = null
// module chunks = 